export default "__VITE_ASSET__CFRth4Jj__"